// Pure helpers for the moderator's area directory (AreaPeopleView.web.tsx)
// and the Assign form's match against parties already on a plan
// (DefensePlanAssignForm.web.tsx).
import type { AreaContact, PlanParty } from '../types';

function norm(value: string | undefined): string {
  return (value ?? '').trim().toLowerCase();
}

// Assign prefers an existing party already on this plan over creating a new
// one: same person name and same organization (case-insensitive, trimmed).
// An empty organization on both sides counts as a match too — a person with
// no organization set either place is still the same person.
export function matchExistingPartyForContact(
  parties: Record<string, PlanParty>,
  contact: Pick<AreaContact, 'name' | 'organization'>
): PlanParty | null {
  const name = norm(contact.name);
  const organization = norm(contact.organization);
  for (const party of Object.values(parties)) {
    if (norm(party.person) === name && norm(party.organization) === organization) {
      return party;
    }
  }
  return null;
}

// The People sheet's search box, shown once there are more than 8 entries.
// Matches name, organization or role, case-insensitively, anywhere in the
// string.
export function filterAreaContacts(contacts: AreaContact[], search: string): AreaContact[] {
  const q = search.trim().toLowerCase();
  if (!q) return contacts;
  return contacts.filter(
    (c) => norm(c.name).includes(q) || norm(c.organization).includes(q) || norm(c.role).includes(q)
  );
}
